import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { MultipleFileUploadField } from "../components/FileUpload/MultipleFileUploadField";
import Textarea from "../components/Form/Textarea";
import InputText from "../components/Form/InputText";
import RadioGroup from "../components/Form/RadioGroup";

export default function SurchargeNumber() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/biljettdetaljer");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    surchargenumber: Yup.string()
                        .required("Vänligen fyll i det tilläggsavgiftsnummer som det gäller.")
                        .min(12, "Vänligen fyll i alla 12 siffror i tilläggsavgiftsnummret. ")
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"11"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="surChargeNumberHeading">
                                    Vilken tilläggsavgift ska överklagas?
                                </h2>

                                <p>
                                    Ange numret som står på det kort du fått. Numret börjar alltid med 4745.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="surchargenumber"
                                    label={
                                        <>
                                            Tilläggsavgiftsnummer <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    moreinfo="12 siffror"
                                    type="number"
                                    maxLength={12}
                                />

                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
